<template>
  <UIOfflineOverlay />
  <DeviceReplaceSimNotification />
  <ImitationBar />
  <RouterView />
  <ModalManager />
  <PasskeyEnrollmentModal
    :on-register="handlePasskeyRegister"
    :on-check-has-passkeys="checkHasPasskeys"
  />
</template>

<script setup>
import { onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useFavicon } from '@vueuse/core';
import ModalManager from '@/components/_common/modals/ModalManager.vue';
import ImitationBar from '@/components/_common/ImitationBar.vue';
import DeviceReplaceSimNotification from './components/device/_common/DeviceReplaceSimNotification.vue';
import { PasskeyEnrollmentModal, usePasskeyAuth } from '@gpx-spa/ui';
import { is_b2b_platform } from '@/utils/b2b-account';
import * as events from '@/events';
import service from '@/services';

const { register } = usePasskeyAuth();

async function handlePasskeyRegister() {
  const optionsRes = await service.post('/passkeys/register/options');
  const credential = await register(optionsRes.data);
  await service.post('/passkeys/register', { ...credential, friendly_name: 'My passkey' });
}

async function checkHasPasskeys() {
  try {
    const res = await service.get('/passkeys');
    return (res.data?.data || []).length > 0;
  } catch {
    return true;
  }
}

const route = useRoute();

onMounted(() => {
  setFavicon();
  setTheme();
});

watch(
  () => route.name,
  (to, from) => {
    if (!from && !to) {
      return;
    }

    events.trigger(events.names.PAGE_VIEWED, {
      to,
      from,
    });
  },
  {
    immediate: true,
  },
);

function setTheme() {
  is_b2b_platform
    ? document.body.classList.add('b2b')
    : document.body.classList.remove('b2b');
}

function setFavicon() {
  const icon = useFavicon();
  icon.value = is_b2b_platform
    ? 'gpx-favicon-192.png'
    : 'logistimatics-favicon-192.png';
}
</script>
